/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-sequences */
/* eslint-disable eqeqeq */
/* eslint-disable no-redeclare */
/* eslint-disable new-parens */
var BigInteger = require('./jsbn'),
  SecureRandom = require('./rng'),
  NodeRSA = require('node-rsa');
function parseBigInt(a, b) {
  return new BigInteger(a, b);
}
function linebrk(a, b) {
  for (var c = '', d = 0; d + b < a.length; ) (c += a.substring(d, d + b) + '\n'), (d += b);
  return c + a.substring(d, a.length);
}
function byte2Hex(a) {
  return 16 > a ? '0' + a.toString(16) : a.toString(16);
}
function pkcs1pad2(a, b) {
  if (b < a.length + 11) return null;
  for (var d, e = [], f = a.length - 1; 0 <= f && 0 < b; )
    (d = a.charCodeAt(f--)),
      128 > d
        ? (e[--b] = d)
        : 127 < d && 2048 > d
        ? ((e[--b] = 128 | (63 & d)), (e[--b] = 192 | (d >> 6)))
        : ((e[--b] = 128 | (63 & d)), (e[--b] = 128 | (63 & (d >> 6))), (e[--b] = 224 | (d >> 12)));
  e[--b] = 0;
  for (var g = new SecureRandom(), h = []; 2 < b; ) {
    for (h[0] = 0; 0 === h[0]; ) g.nextBytes(h);
    e[--b] = h[0];
  }
  return (e[--b] = 2), (e[--b] = 0), new BigInteger(e);
}
function RSAKey() {
  (this.n = null),
    (this.e = 0),
    (this.d = null),
    (this.p = null),
    (this.q = null),
    (this.dmp1 = null),
    (this.dmq1 = null),
    (this.coeff = null);
}
function RSAGetPublicString() {
  var a = { n: this.n.toString(16), e: this.e.toString(16) };
  return 1 == a.n.length % 2 && (a.n = '0' + a.n), JSON.stringify(a);
}
function RSAGetPrivateString() {
  var a = {},
    b = this;
  return (
    ['n', 'e', 'd', 'p', 'q', 'dmp1', 'dmq1', 'coeff'].forEach(function (c) {
      (a[c] = b[c] && b[c].toString(16)), 'e' !== c && 1 == a[c].length % 2 && (a[c] = '0' + a[c]);
    }),
    JSON.stringify(a)
  );
}
function RSASetPrivateString(a) {
  var b = JSON.parse(a);
  return this.setPrivateEx(b);
}
function RSASetPublic(a, b) {
  null !== a && null !== b && 0 < a.length && 0 < b.length
    ? ((this.n = parseBigInt(a, 16)), (this.e = parseInt(b, 16)))
    : console.log('Invalid RSA public key');
}
function RSASetPublicString(a) {
  var b = JSON.parse(a);
  return this.setPublic(b.n, b.e);
}
function RSASetPublicCert(a) {
  var b = new NodeRSA();
  b.importKey(a, 'pkcs8-public');
  var c = { n: b.keyPair.n.toString(16), e: b.keyPair.e.toString(16) };
  return 1 == c.n.length % 2 && (c.n = '0' + c.n), this.setPublic(c.n, c.e);
}
function RSADoPublic(a) {
  return a.modPowInt(this.e, this.n);
}
function RSAEncrypt(a) {
  var b = pkcs1pad2(a, (this.n.bitLength() + 7) >> 3);
  if (null === b) return null;
  var d = this.doPublic(b);
  if (null === d) return null;
  var c = d.toString(16);
  return 0 == (1 & c.length) ? c : '0' + c;
}
function RSAEncryptPrivate(a) {
  var b = pkcs1pad2(a, (this.n.bitLength() + 7) >> 3);
  if (null === b) return null;
  var d = this.doPrivate(b);
  if (null === d) return null;
  var c = d.toString(16);
  return 0 == (1 & c.length) ? c : '0' + c;
}
function RSAEncryptB64(a) {
  var b = this.encrypt(a);
  return b ? hex2b64(b) : null;
}
function hex2b64(a) {
  var b,
    d,
    e = '';
  for (b = 0; b + 3 <= a.length; b += 3)
    (d = parseInt(a.substring(b, b + 3), 16)),
      (e +=
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt(d >> 6) +
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt(63 & d));
  for (
    b + 1 === a.length
      ? ((d = parseInt(a.substring(b, b + 1), 16)),
        (e += 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt(d << 2)))
      : b + 2 === a.length &&
        ((d = parseInt(a.substring(b, b + 2), 16)),
        (e +=
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt(d >> 2) +
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt((3 & d) << 4)));
    0 < (3 & e.length);

  )
    e += '=';
  return e;
}
(RSAKey.prototype.doPublic = RSADoPublic),
  (RSAKey.prototype.setPublic = RSASetPublic),
  (RSAKey.prototype.encrypt = RSAEncrypt),
  (RSAKey.prototype.encryptPrivate = RSAEncryptPrivate),
  (RSAKey.prototype.encrypt_b64 = RSAEncryptB64);
function pkcs1unpad2(a, d) {
  for (var e = a.toByteArray(), b = 0; b < e.length && 0 === e[b]; ) ++b;
  if (e.length - b != d - 1 || 2 !== e[b]) return null;
  for (++b; 0 !== e[b]; ) if (++b >= e.length) return null;
  for (var f = ''; ++b < e.length; ) {
    var g = 255 & e[b];
    128 > g
      ? (f += String.fromCharCode(g))
      : 191 < g && 224 > g
      ? ((f += String.fromCharCode(((31 & g) << 6) | (63 & e[b + 1]))), ++b)
      : ((f += String.fromCharCode(((15 & g) << 12) | ((63 & e[b + 1]) << 6) | (63 & e[b + 2]))),
        (b += 2));
  }
  return f;
}
function RSASetPrivate(a, b, c) {
  null !== a && null !== b && 0 < a.length && 0 < b.length
    ? ((this.n = parseBigInt(a, 16)), (this.e = parseInt(b, 16)), (this.d = parseBigInt(c, 16)))
    : console.log('Invalid RSA private key');
}
function RSASetPrivateCert(a) {
  var b = new NodeRSA();
  b.importKey(a);
  var c = b.keyPair.n.toString(16),
    d = b.keyPair.e.toString(16),
    e = b.keyPair.d.toString(16);
  1 == c % 2 && (c = '0' + c),
    null !== c && null !== d && 0 < c.length && 0 < d.length
      ? ((this.n = parseBigInt(c, 16)), (this.e = parseInt(d, 16)), (this.d = parseBigInt(e, 16)))
      : console.log('Invalid RSA private key');
}
function RSASetPrivateEx(a, b, c, d, e, f, g, h) {
  var i = {};
  'object' == typeof a
    ? (i = a)
    : ((i.n = a),
      (i.e = b),
      (i.d = c),
      (i.p = d),
      (i.q = e),
      (i.dmp1 = f),
      (i.dmq1 = g),
      (i.coeff = h)),
    null !== i.n && null !== i.e && 0 < i.n.length && 0 < i.e.length
      ? ((this.n = parseBigInt(i.n, 16)),
        (this.e = parseInt(i.e, 16)),
        (this.d = parseBigInt(i.d, 16)),
        (this.p = parseBigInt(i.p, 16)),
        (this.q = parseBigInt(i.q, 16)),
        (this.dmp1 = parseBigInt(i.dmp1, 16)),
        (this.dmq1 = parseBigInt(i.dmq1, 16)),
        (this.coeff = parseBigInt(i.coeff, 16)))
      : console.log('Invalid RSA private key');
}
function RSAGenerate(a, b) {
  var c = new SecureRandom(),
    d = a >> 1;
  this.e = parseInt(b, 16);
  for (var e = new BigInteger(b, 16); ; ) {
    for (;;)
      if (
        ((this.p = new BigInteger(a - d, 1, c)),
        0 === this.p.subtract(BigInteger.ONE).gcd(e).compareTo(BigInteger.ONE) &&
          this.p.isProbablePrime(10))
      )
        break;
    for (;;)
      if (
        ((this.q = new BigInteger(d, 1, c)),
        0 === this.q.subtract(BigInteger.ONE).gcd(e).compareTo(BigInteger.ONE) &&
          this.q.isProbablePrime(10))
      )
        break;
    if (0 >= this.p.compareTo(this.q)) {
      var f = this.p;
      (this.p = this.q), (this.q = f);
    }
    var g = this.p.subtract(BigInteger.ONE),
      h = this.q.subtract(BigInteger.ONE),
      i = g.multiply(h);
    if (0 === i.gcd(e).compareTo(BigInteger.ONE)) {
      (this.n = this.p.multiply(this.q)),
        (this.d = e.modInverse(i)),
        (this.dmp1 = this.d.mod(g)),
        (this.dmq1 = this.d.mod(h)),
        (this.coeff = this.q.modInverse(this.p));
      break;
    }
  }
}
function RSADoPrivate(a) {
  if (null === this.p || null === this.q) return a.modPow(this.d, this.n);
  for (
    var b = a.mod(this.p).modPow(this.dmp1, this.p), c = a.mod(this.q).modPow(this.dmq1, this.q);
    0 > b.compareTo(c);

  )
    b = b.add(this.p);
  return b.subtract(c).multiply(this.coeff).mod(this.p).multiply(this.q).add(c);
}
function RSADecrypt(a) {
  var b = b642hex(a),
    d = parseBigInt(b, 16),
    c = this.doPrivate(d);
  if (null === c) return null;
  var e = pkcs1unpad2(c, (this.n.bitLength() + 7) >> 3);
  return e;
}
function b642hex(a) {
  var b,
    c,
    d = '',
    e = 0;
  for (b = 0; b < a.length && a.charAt(b) !== '='; ++b) {
    var f = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.indexOf(a.charAt(b));
    0 > f ||
      (0 === e
        ? ((d += int2char(f >> 2)), (c = 3 & f), (e = 1))
        : 1 === e
        ? ((d += int2char((c << 2) | (f >> 4))), (c = 15 & f), (e = 2))
        : 2 === e
        ? ((d += int2char(c)), (d += int2char(f >> 2)), (c = 3 & f), (e = 3))
        : ((d += int2char((c << 2) | (f >> 4))), (d += int2char(15 & f)), (e = 0)));
  }
  return 1 === e && (d += int2char(c << 2)), d;
}
function int2char(a) {
  return '0123456789abcdefghijklmnopqrstuvwxyz'.charAt(a);
}
function RSADecryptPublic(a) {
  var b = parseBigInt(a, 16),
    c = this.doPublic(b);
  return null === c ? null : pkcs1unpad2(c, (this.n.bitLength() + 7) >> 3);
}
(RSAKey.prototype.doPrivate = RSADoPrivate),
  (RSAKey.prototype.setPrivate = RSASetPrivate),
  (RSAKey.prototype.setPrivateEx = RSASetPrivateEx),
  (RSAKey.prototype.setPrivateCert = RSASetPrivateCert),
  (RSAKey.prototype.generate = RSAGenerate),
  (RSAKey.prototype.decrypt = RSADecrypt),
  (RSAKey.prototype.decryptPublic = RSADecryptPublic),
  (RSAKey.prototype.getPublicString = RSAGetPublicString),
  (RSAKey.prototype.setPublicCert = RSASetPublicCert),
  (RSAKey.prototype.setPublicString = RSASetPublicString),
  (RSAKey.prototype.getPrivateString = RSAGetPrivateString),
  (RSAKey.prototype.setPrivateString = RSASetPrivateString),
  (RSAKey.prototype.linebrk = linebrk);

export default RSAKey;
